module.exports = __webpack_public_path__ + "img/Diseño-SItio-web_04.a04c08f5.jpg";